import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const UserLinkRenderer = (props) => {
  return (
    <Link to={`/authorization/users/${props.data.id}`}>{props.value}</Link>
  );
};

UserLinkRenderer.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  value: PropTypes.node
};

export default UserLinkRenderer;
